
export default function actionSearchProduct(status, query) {
  return (dispatch) => {
    dispatch({        
      type: 'SEARCH_PRODUCT',
      status: status,
      query: query
    })
  }
}